var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wechtLogin"},[_c('WechatLogo',{attrs:{"redirectUri":_vm.redirectUri}}),_vm._v(" "),_c('div',{staticClass:"topInfoRight"},[_c('span',[_vm._v(_vm._s(_vm.$t('已有账号')))]),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.switchTabs('login')}}},[_vm._v(_vm._s(_vm.$t('去登录')))])])],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }